/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Moderate_Promote_NationalInputs */



/**
* | output |
* | --- |
* | "Pin nationally" |
*
* @param {Community_Moderate_Promote_NationalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_moderate_promote_national = /** @type {((inputs?: Community_Moderate_Promote_NationalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Moderate_Promote_NationalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Épingler nationalement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fijar nacionalmente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fixar nacionalmente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fissa nazionalmente")
	return /** @type {LocalizedString} */ ("Pin nationally")
});